import wrapWithProvider from './wrap-with-providerBrowser'

export const wrapRootElement = wrapWithProvider
